import { Injectable } from '@angular/core'

import { Observable } from 'rxjs/Observable'

import { LectureApiBase } from './lecture-api'
import { StaticContent } from '../models'
import { PaginatedList } from '../libs/infinite-paginator'
import { isFunctionLike } from 'typescript'

@Injectable()
export class StaticContentApi {
  private apiPath = 'static_contents'

  constructor(
    private api: LectureApiBase,
  ) { }

  index(videoId: number): PaginatedList<StaticContent> {
    return this.api.listWithPaginate<StaticContent>(StaticContent, this.api.makeUrlWithParams(this.apiPath, { videoId }))
  }

  get(id: number): Observable<StaticContent> {
    return this.api.getWithObject(StaticContent, `${this.apiPath}/${id}`)
  }

  update(id: number, params: any): Observable<StaticContent> {
    return this.api.putWithObject<StaticContent>(StaticContent,`${this.apiPath}/${id}`, params)
  }

  create(videoId: number, name: string, file: ActiveStorage.Blob): Observable<StaticContent> {
    return this.api.postWithObject<StaticContent>(StaticContent, this.apiPath, { videoId: videoId, name, file: file.signed_id })
  }
}



// WEBPACK FOOTER //
// ./src/apis/static-content.ts